export default __webpack_public_path__ + "static/media/nih-logo.2d78086b.svg";